export const fnReportError = ({ message }) => {
  console.error(message);
};

export const fnThrowError = ({ message }) => {
  throw new Error(message);
};
